import { TabPanel, TabPanelProps } from "@mui/lab";
import { styled } from "@mui/material";

const ModuleTabPanel = styled((props: TabPanelProps) => (
  <TabPanel {...props} />
))(() => ({
  "&.MuiTabPanel-root": {
    position: "relative",
    padding: "0px",
    marginTop: "0px",
    width: "100%",
  },
}));

export default ModuleTabPanel;
